import { render, staticRenderFns } from "./barcode.vue?vue&type=template&id=13495fdd"
import script from "./barcode.vue?vue&type=script&lang=js"
export * from "./barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports